const MixpanelEvents = {
  NOTIFICATION_BADGE_CLICKED: "Notification badge clicked",
  NOTIFICATION_ITEM_CLICKED: "Notification item clicked",
  NOTIFICATION_READ_ALL: "Notification read all",

  PROPERTIES_FILTERED: "Properties filtered",

  CHECKIN_BADGE_CLICKED: "Check-in badge clicked",
  CHECKIN_TO_CONFIRM_ITEM_CLICKED: "Check-in to confirm item clicked",

  RECEPTION_NOTES_OPENED: "Reception notes opened",
  RECEPTION_NOTES_SAVED: "Reception notes saved",

  EMERGENCY_CONTACT_OPEN: "Emergency contact opened",

  GLOBAL_SEARCH_PERFORMED: "Global search performed",
  GLOBAL_SEARCH_ITEM_CLICKED: "Global search item clicked",
  MENU_COLLAPSED: "Menu collapsed",

  WEBPUSH_NOTIFICATIONS_ENABLED: "Webpush Notifications Enabled",
  WEBPUSH_NOTIFICATIONS_DISABLED: "Webpush Notifications Disabled",

  RESERVATION_SOURCE_PERIOD_CHANGED: "Reservation source period changed",
  ECONOMICS_PRIVACY_TOGGLE: "Economics privacy toggle",
  RESERVATIONS_VIEW: "Reservations view",

  USER_PROPERTY_CLUSTER_CREATED: "User property cluster created",
  USER_PROPERTY_CLUSTER_UPDATED: "User property cluster updated",

  COMPANY_PROPERTY_CLUSTER_CREATED: "Company property cluster created",
  COMPANY_PROPERTY_CLUSTER_UPDATED: "Company property cluster updated",

  SINGLE_RESERVATION_NEW: "Single reservation new",
  SINGLE_RESERVATION_CREATED: "Single reservation created",
  MULTIPLE_RESERVATION_NEW: "Multiple reservation new",
  MULTIPLE_RESERVATION_CREATED: "Multiple reservation created",

  RESERVATION_EDITED: "Reservation edited",
  RESERVATION_LIST_PRINTED: "Reservation list printed",
  RESERVATION_SINGLE_PRINTED: "Reservation single printed",
  RESERVATION_LIST_EXPORTED: "Reservation list exported",
  RESERVATION_SPLITTED: "Reservation splitted",
  RESERVATION_SPLIT_DELETE: "Reservation split delete",

  PLANNER_TASK_COMPLETED: "Planner task completed",
  PLANNER_TASK_ASSIGNED: "Planner task assigned",
  PLANNER_TASKS_EXPORTED: "Planner tasks exported",
  PLANNER_TASK_LIST_FILTERED: "Planner task list filtered",

  CALENDAR_PRESET_VIEW_SAVED: "Calendar Preset View saved",
  CALENDAR_PRESET_VIEW_CHANGED: "Calendar Preset View changed",
  CALENDAR_PRESET_VIEW_CHOOSED: "Calendar Preset View choosed",

  // UNIT_CATEGORY_OPEN: 'Unit category open',
  // UNIT_OPEN: 'Unit open',
  // OCCUPANCY_PRICE_OPEN: 'Occupancy price open',

  CALENDAR_ACTION_TRIGGERED: "Calendar Action Triggered",
  // DERIVATION_RULE_OPEN: 'Derivation rule open',
  SINGLE_RATE_UPDATED: "Single rate updated",
  RATES_BULK_UPDATED: "Rates bulk updated",

  RESERVATION_DRAGGED: "Reservation dragged",
  RESERVATION_DRAG_CONFIRMED: "Reservation drag confirmed",
  CALENDAR_NAVIGATED: "Calendar navigated",

  PAYMENT_CREATED: "Payment created",
  PAYMENT_UPDATED: "Payment updated",

  TEMPLATE_CREATED: "Template created",
  TEMPLATE_BULK_CREATED: "Template bulk created",
  TEMPLATE_EDITED: "Template edited",
  TEMPLATE_COPIED: "Template copied",
  TEMPLATE_DUPLICATED: "Template duplicated",

  EXTRA_CREATED: "Extra created",
  EXTRA_EDITED: "Extra edited",

  PROPERTY_COST_CREATED: "Property cost created",
  PROPERTY_COST_BULK_CREATED: "Property cost bulk created",
  PROPERTY_COST_DELETED: "Property cost deleted",
  PROPERTY_COST_BULK_DELETED: "Property cost bulk deleted",

  DYNAMIC_COST_CREATED: "Dynamic cost created",
  DYNAMIC_COST_UPDATED: "Dynamic cost updated",
  DYNAMIC_COST_BULK_DELETED: "Dynamic cost bulk deleted",
  DYNAMIC_COST_DELETED: "Dynamic cost deleted",
  DYNAMIC_COST_REGENERATED: "Dynamic cost regenerated",

  PROMOTION_CREATED: "Promotion created",

  HOUSEKEEPING_CALENDAR_FILTERED: "Housekeeping calendar filtered",
  HOUSEKEEPING_CALENDAR_EXPORT: "Housekeeping Calendar Export",
  HOUSEKEEPING_CALENDAR_PRINT: "Housekeeping Calendar Print",
  HOUSEKEEPING_TASK_COMPLETED: "Housekeeping task completed",
  HOUSEKEEPING_TASK_CREATED: "Housekeeping task created",
  HOUSEKEEPING_TASK_UPDATED: "Housekeeping task updated",

  POLICE_ACCOUNT_CREATED: "Police account created",
  POLICE_ACCOUNT_UPDATED: "Police account updated",
  POLICE_FILE_DOWNLOADED: "Police file downloaded",
  POLICE_RECEIPT_LIST_OPENED: "Police receipt list opened",
  POLICE_RECEIPT_DOWNLOADED: "Police receipt downloaded",

  STAT_ACCOUNT_CREATED: "Stat account created",
  STAT_ACCOUNT_UPDATED: "Stat account updated",
  STAT_ACCOUNT_MANUAL_SUBMIT: "Stat account manual submit",
  STAT_ACCOUNT_FILE_DOWNLOAD: "Stat account file download",

  CHECKIN_CREATED: "Check-in created",
  CHECKIN_UPDATED: "Check-in updated",
  CHECKIN_DELETED: "Check-in deleted",
  CHECKIN_OPENED: "Check-in opened",

  CHECKIN_GUEST_OPENED: "Check-in guest opened",
  CHECKIN_GUEST_REMOVED: "Check-in guest removed",
  CHECKIN_SELFIE_OPENED: "Selfie opened",
  CHECKIN_GUEST_ADDED: "Guest added",

  REVENUE_REPORT_GENERATED: "Revenue report generated",
  PRODUCTION_REPORT_GENERATED: "Production report generated",
  AUDIT_REPORT_GENERATED: "Audit report generated",
  RESERVATIONS_REPORT_GENERATED: "Reservations report generated",
  REVENUE_SHARE_REPORT_GENERATED: "Revenue share report generated",
  MANAGEMENT_REPORT_GENERATED: "Management report generated",
  IN_HOUSE_GUESTS_REPORT_GENERATED: "In-house guests report generated",
  EXTRAS_REPORT_GENERATED: "Extras report generated",
  WORK_ORDER_REPORT_GENERATED: "Work order report generated",

  BILL_CREATED: "Bill created",
  BILL_EDITED: "Bill edited",
  BILL_DELETED: "Bill deleted",

  FISCAL_DOC_CREATED: "Fiscal doc created",
  FISCAL_DOC_EDITED: "Fiscal doc edited",

  RMT_GENERATED: "RMT generated",
  RMT_INFO_SAVED: "RMT info saved",

  CMMS_ASSET_CREATED: "CMMS Asset created",
  CMMS_ASSET_EDITED: "CMMS Asset edited",
  CMMS_WORKER_CREATED: "CMMS worker created",
  CMMS_WORKER_EDITED: "CMMS worker edited",
  CMMS_WORK_ORDER_CREATED: "CMMS work order created",
  CMMS_WORK_ORDER_EDITED: "CMMS work order edited",

  QUOTE_CREATED: "Quote created",
  QUOTE_EDITED: "Quote edited",
  QUOTE_SENT_TO_CLIENT: "Quote sent to client",

  CITY_TAX_SETTINGS_CREATED: "City tax settings created",
  SELF_CHECKIN_SETTINGS_SAVED: "Self check-in settings defined",

  PROPERTY_CONTENT_SAVED: "Property content saved",

  UNIT_CATEGORY_CONTENT_CREATED: "Unit category content created",
  UNIT_CATEGORY_CONTENT_UPDATED: "Unit category content updated",

  RATE_PLAN_CREATED: "Rate Plan created",
  RATE_PLAN_UPDATED: "Rate Plan updated",
  RATE_PLAN_DELETED: "Rate Plan deleted",

  DERIVATION_RULE_CREATED: "Derivation Rule created",
  DERIVATION_RULE_UPDATED: "Derivation Rule updated",
  DERIVATION_RULE_DELETED: "Derivation Rule deleted",

  UNIT_CREATED: "Unit created",
  UNIT_UPDATED: "Unit updated",
  UNIT_DELETED: "Unit deleted",

  REVENUE_SHARE_SETTINGS_CREATED: "Revenue share settings created",
  REVENUE_SHARE_SETTINGS_UPDATED: "Revenue share settings updated",
  REVENUE_SHARE_SETTINGS_DELETED: "Revenue share settings deleted",
  REVENUE_SHARE_REGENERATED: "Revenue share regenerated",

  REVENUE_SHARE_RULE_SAVED: "Revenue share rule saved",
  REVENUE_SHARE_RULE_DELETED: "Revenue share rule deleted",

  COMPANY_POLICY_UPDATED: "Company policy updated",

  PROPERTY_POLICY_OVERRIDE: "Property policy override",
  PROPERTY_POLICY_UPDATED: "Property policy updated",

  PROPERTY_BOOKING_SETTINGS_OVERRIDE: "Property booking settings override",
  PROPERTY_BOOKING_SETTINGS_UPDATED: "Property booking settings updated",

  RESOURCE_CREATED: "Resource created",
  RESOURCE_UPDATED: "Resource updated",
  RESOURCE_EVENT_CREATED: "Resource event created",
  RESOURCE_CALENDAR_PRINTED: "Resource calendar printed",

  RESERVATION_EXTRA_CREATED: "Reservation extra created",
  RESERVATION_EXTRA_UPDATED: "Reservation extra updated",

  COMPANY_PAYMENT_AUTOMATION_CONFIGURED:
    "Company payment automation configured",
  PROPERTY_PAYMENT_AUTOMATION_CONFIGURED:
    "Property payment automation configured",
  PAYMENT_AUTOMATION_MANUAL_LINK_CREATED:
    "Payment automation manual link created",
  PAYMENT_AUTOMATION_PAYMENT_MARK_AS_PAID:
    "Payment automation payment mark as paid",
  PAYMENT_AUTOMATION_LINK_COPIED: "Payment automation link copied",
  PAYMENT_AUTOMATION_NOTIFICATIONS_VIEWED:
    "Payment automation notifications viewed"
};

export default MixpanelEvents;
